import { storyblokEditable } from "@storyblok/react";
import { Link } from "react-router";

const ButtonBlock = ({ blok }) => {
  const externallink = blok.buttonlink.cached_url.startsWith("http")
  console.log(blok)
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display ">
        <Link
        to={externallink?blok.buttonlink.cached_url:`/${blok.buttonlink.cached_url}`}
        className="button button-primary"
        label={blok.label}
      >{blok.label}</Link>
      </div>
    </>
  );
};

export default ButtonBlock;
